import { render, staticRenderFns } from "./SureOrder.vue?vue&type=template&id=20edbbd2&scoped=true&"
import script from "./SureOrder.vue?vue&type=script&lang=js&"
export * from "./SureOrder.vue?vue&type=script&lang=js&"
import style0 from "./SureOrder.vue?vue&type=style&index=0&id=20edbbd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20edbbd2",
  null
  
)

export default component.exports